/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import { Auth } from 'aws-amplify';
import axios from 'axios';
import { debounce } from 'debounce';
import { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Button, Flex, Input, Label, Link, Paragraph, Switch, Textarea } from 'theme-ui';
import Sidebar from '../components/sidebar';
import Spinner from '../components/spinner';
import { actions as menuActions } from '../store/reducers/menu';
import { actions as userActions } from '../store/reducers/users';
import { defaultOverlayState, defaultSettings } from '../utils/default-states';
import ConfirmDialog from '../components/tasks/confirm-dialog';
import Divider from '../components/divider';
import moment from 'moment';
import ReactSelect from 'react-select';
import theme from '../theme';
import { toast } from 'react-toastify';
import ReactQuill, { Quill } from 'react-quill';
import { ImageDrop } from 'quill-image-drop-module';
import QuillResizeImage from 'quill-resize-image';

Quill.register('modules/imageDrop', ImageDrop);
Quill.register('modules/resize', QuillResizeImage);

const ImageFormat = Quill.import('formats/image');

class CustomImage extends ImageFormat {
    static formats(domNode) {
        return {
            ...super.formats(domNode),
            style: domNode.getAttribute('style'), // Retain the style attribute
        };
    }

    format(name, value) {
        if (name === 'style') {
            if (value) {
                this.domNode.setAttribute('style', value);
            } else {
                this.domNode.removeAttribute('style');
            }
        } else {
            super.format(name, value);
        }
    }
}

// Register the Custom Image Format
Quill.register(CustomImage, true);

const defaultState = {
    loading: true,
    partialLoading: false,
    error: null,
};

export const attributeTypes = [
    {
        value: 'date',
        label: 'Date',
    },
    {
        value: 'string',
        label: 'Text',
    },
    {
        value: 'textarea',
        label: 'Text area (multi-line answer)',
    },
    {
        value: 'signature',
        label: 'Signature',
    },
    {
        value: 'address',
        label: 'Address',
    },
    {
        value: 'number',
        label: 'Number',
    },
    {
        value: 'dropdown',
        label: 'Dropdown',
    },
    {
        value: 'file',
        label: 'File Upload',
    },
    {
        value: 'multiple_files',
        label: 'Multiple File Upload',
    },
];

const deleteProposal = (id, state, updateState) => async () => {
    try {
        updateState({ ...state, loading: true, error: null });

        await axios({
            url: `${process.env.REACT_APP_AQRU_AI_API}/template-proposals/${id}`,
            method: 'DELETE',
        });

        const {
            data: { proposals },
        } = await axios({
            url: `${process.env.REACT_APP_AQRU_AI_API}/template-proposals`,
        });

        updateState({
            ...state,
            loading: false,
            error: null,
            proposals,
            proposalsFiltered: proposals,
            view: 'list',
        });
    } catch (e) {
        updateState({ ...state, loading: false });
        toast('We are currently unable to delete your proposal', { type: 'error' });
    }
};

const saveProposal = async (state, updateState, fireAndForgetSave = false) => {
    try {
        if (!fireAndForgetSave) {
            updateState({ ...state, loading: true, error: null });
        }

        const keyValuePairs = {
            name: state.proposal?.name,
            description: state.proposal?.description,
            definition: state.proposal.definition || {},
        };

        const payloadStringified = JSON.stringify(keyValuePairs);

        if (fireAndForgetSave && state.lastPayload && state.lastPayload === payloadStringified) {
            return;
        }

        const { data } = await axios({
            url: `${process.env.REACT_APP_AQRU_AI_API}/template-proposals${
                state.proposal?.id ? `/${state.proposal?.id}` : ''
            }`,
            method: state.proposal?.id ? 'PUT' : 'POST',
            data: keyValuePairs,
        });

        const {
            data: { proposals },
        } = await axios({
            url: `${process.env.REACT_APP_AQRU_AI_API}/template-proposals`,
        });

        updateState({
            ...state,
            loading: false,
            error: null,
            proposals,
            lastPayload: state.proposal?.id ? payloadStringified : null,
            proposalsFiltered: proposals,
            proposal: {
                ...state.proposal,
                updated_at: moment(),
                id: state.proposal?.id || data.id,
            },
        });

        if (!fireAndForgetSave) {
            toast('Proposal saved', { type: 'success' });
        }
    } catch (e) {
        console.log(e);
        updateState({ ...state, loading: false });
        toast('We are currently unable to save your proposal', { type: 'error' });
    }
};

const clone = async (proposal, state, updateState) => {
    try {
        updateState({ ...state, loading: true, error: null });

        await axios({
            url: `${process.env.REACT_APP_AQRU_AI_API}/template-proposals`,
            method: 'POST',
            data: {
                name: proposal?.name + ' - CLONE',
                description: proposal.description,
                definition: proposal.definition,
            },
        });

        const {
            data: { proposals },
        } = await axios({
            url: `${process.env.REACT_APP_AQRU_AI_API}/template-proposals`,
        });

        updateState({
            ...state,
            loading: false,
            error: null,
            proposals,
            proposalsFiltered: proposals,
            view: 'list',
        });
    } catch (e) {
        updateState({ ...state, loading: false, error: 'We are currently unable to clone your proposal' });
    }
};

export const ConfigureProposal = ({ cancelHandler, saveHandler, state, updateState, organisation }) => {
    const quillRef = useRef(null);
    const [cursorPosition, setCursorPosition] = useState(null);

    return (
        <Flex
            sx={{
                paddingRight: 30,
                paddingBottom: 30,
                mt: 20,
                flexDirection: 'column',
                width: 1240,
                ml: 10,
            }}
        >
            <Paragraph sx={{ fontWeight: 600, mt: 0, fontSize: 25 }}>
                {state.proposal?.id ? 'Edit proposal' : 'Add new proposal'}
            </Paragraph>

            <Divider />

            <Label sx={{ mt: 0 }}>Name</Label>
            <Input
                onChange={(e) =>
                    updateState({
                        ...state,
                        proposal: {
                            ...state.proposal,
                            name: e.target.value,
                        },
                    })
                }
                value={state.proposal?.name}
                sx={{ width: 300, height: 40, mt: 10 }}
            />

            <Label sx={{ mt: 30 }}>Description</Label>
            <Textarea
                rows={5}
                onChange={(e) =>
                    updateState({
                        ...state,
                        proposal: {
                            ...state.proposal,
                            description: e.target.value,
                        },
                    })
                }
                value={state.proposal?.description}
                sx={{ width: 500, mt: 10, mb: 20 }}
            />

            <Flex sx={{ flexDirection: 'column', width: 400, mb: 40 }}>
                <Label id="reminders-label" sx={{ mr: 30 }}>
                    Reminders
                </Label>
                <ReactSelect
                    aria-labelledby="reminders-label"
                    styles={{
                        control: (provided) => ({
                            ...provided,
                            boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.2)',
                            width: '370px',
                            minHeight: '40px',
                            marginTop: '10px',
                            borderRadius: 10,
                            border: `1px solid #a3a69b`,
                            fontSize: '14px',
                        }),
                    }}
                    isMulti
                    onChange={async (c) => {
                        updateState({
                            ...state,
                            proposal: {
                                ...state.proposal,
                                definition: {
                                    ...(state.proposal.definition || {}),
                                    reminders: c,
                                },
                            },
                        });
                    }}
                    placeholder="Select..."
                    value={state.proposal.definition?.reminders || []}
                    options={[
                        {
                            value: 1,
                            label: '1 Day after',
                        },
                        {
                            value: 2,
                            label: '2 Days after',
                        },
                        {
                            value: 3,
                            label: '3 Days after',
                        },
                        {
                            value: 4,
                            label: '4 Days after',
                        },
                        {
                            value: 5,
                            label: '5 Days after',
                        },
                        {
                            value: 6,
                            label: '6 Days after',
                        },
                        {
                            value: 7,
                            label: '1 week after',
                        },
                        {
                            value: 14,
                            label: '2 weeks after',
                        },
                    ]}
                />
            </Flex>

            <Flex sx={{ mt: 0, flexDirection: 'column', width: 600, mb: 60 }}>
                <Label id="task-desc" sx={{}}>
                    Template proposal letter
                </Label>
                <Divider />
                <ReactSelect
                    aria-labelledby="service-label"
                    styles={{
                        control: (provided) => ({
                            ...provided,
                            boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.2)',
                            width: '370px',
                            minHeight: '40px',
                            borderRadius: 10,
                            border: `1px solid #a3a69b`,
                            fontSize: '14px',
                        }),
                    }}
                    onChange={async (c) => {
                        const value = `{${c.value}}`;

                        if (quillRef.current) {
                            if (cursorPosition !== null) {
                                const editor = quillRef.current.getEditor();
                                if (editor) {
                                    editor.insertText(cursorPosition, value, 'user');
                                    setCursorPosition(cursorPosition + value.length);
                                }
                            } else {
                                const editor = quillRef.current.getEditor();
                                if (editor) {
                                    editor.insertText(0, value, 'user');
                                    setCursorPosition(0);
                                }
                            }
                        }
                    }}
                    placeholder="Select a dynamic token for your letter"
                    options={[
                        { value: 'client.name', label: 'Client name' },
                        { value: 'client.services', label: 'Client services' },
                        { value: 'today', label: 'Todays Date' },
                    ]}
                />
                <ReactQuill
                    modules={{
                        toolbar: {
                            container: [
                                [{ header: '1' }, { header: '2' }],
                                ['bold', 'italic', 'underline', 'strike'],
                                [{ align: [] }],
                                [{ list: 'ordered' }, { list: 'bullet' }],
                                ['image'],
                            ],
                        },
                        imageDrop: true,
                        resize: {
                            locale: {},
                        },
                    }}
                    formats={['image', 'align', 'style']}
                    ref={quillRef}
                    theme="snow"
                    value={state.proposal?.definition?.html}
                    style={{ minHeight: 400, marginTop: 20 }}
                    onChange={(val, delta, source, editor) => {
                        updateState({
                            ...state,
                            proposal: {
                                ...state.proposal,
                                definition: {
                                    ...(state.proposal.definition || {}),
                                    html: editor.getHTML(),
                                },
                            },
                        });

                        if (quillRef) {
                            const editor = quillRef.current?.getEditor();
                            if (editor) {
                                const currentCursorPosition = editor.getSelection()?.index || 0;
                                setCursorPosition(currentCursorPosition);
                            }
                        }
                    }}
                />
            </Flex>

            <Flex
                sx={{
                    position: 'fixed',
                    height: 80,
                    background: 'white',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    alignItems: 'center',
                    borderTop: '2px solid #EFEFEF',
                    width: '100%',
                    zIndex: 998,
                }}
            >
                <Button
                    variant="light"
                    sx={{ width: 120, ml: 20 }}
                    onClick={async () => {
                        const {
                            data: { proposals },
                        } = await axios({
                            url: `${process.env.REACT_APP_AQRU_AI_API}/template-proposals`,
                        });
                        updateState({ ...state, proposals, proposalsFiltered: proposals, proposal: {}, view: 'list' });
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}
                >
                    <i
                        style={{
                            fontSize: '12px',
                            cursor: 'pointer',
                            marginRight: '7px',
                        }}
                        className="fas fa-chevron-left"
                        aria-hidden="true"
                    />
                    Back
                </Button>
                <Button
                    sx={{ ml: 20, width: 120, height: 40, fontSize: 14 }}
                    onClick={async () => {
                        await saveProposal(state, updateState);
                    }}
                >
                    <i
                        style={{
                            fontSize: '12px',
                            cursor: 'pointer',
                            marginRight: '7px',
                        }}
                        className="fas fa-save"
                        aria-hidden="true"
                    />
                    Save
                </Button>
                {state.proposal.updated_at ? (
                    <Paragraph sx={{ ml: 30 }}>
                        Last saved: {moment(state.proposal.updated_at).format('HH:mm DD/MM/YYYY')}
                    </Paragraph>
                ) : null}
            </Flex>
        </Flex>
    );
};

export const lookupAttributeOptions = (organisation) => [
    ...Object.entries(organisation?.schema || {})?.map((x) => ({
        value: x[0],
        label: x[1]?.label,
        type: x[1]?.type,
    })),
    { value: 'contact.title', label: 'Contact Title', type: 'string' },
    { value: 'contact.first_name', label: 'Contact First Name', type: 'string' },
    { value: 'contact.middle_name', label: 'Contact Middle Name', type: 'string' },
    { value: 'contact.last_name', label: 'Contact Last Name', type: 'string' },
    { value: 'contact.job_title', label: 'Contact Job Title', type: 'string' },
    { value: 'contact.telephone_number', label: 'Contact Telephone Number', type: 'string' },
    { value: 'contact.address', label: 'Contact Address', type: 'address' },
    { value: 'contact.preferred_name', label: 'Preferred Name', type: 'string' },
];

const Proposals = ({ refreshCoreData, logout, userData, accountSummary, organisation }) => {
    const [state, updateState] = useState({
        ...defaultState,
        organisation,
        view: 'list',
        proposal: null,
    });
    const [user, updateUser] = useState(userData);
    const [overlay, updateOverlay] = useState(defaultOverlayState);

    const [settingsJourney, updateSettingsJourney] = useState(defaultSettings);
    const navigate = useNavigate();

    const handleSearchByNameChange = debounce(async (e) => {
        updateState({
            ...state,
            proposalsFiltered: state.proposals?.filter((x) => x?.name?.toLowerCase()?.startsWith(e.target.value)),
        });
    }, 500);

    const stateRef = useRef();
    stateRef.current = state;

    useEffect(() => {
        stateRef.current = state;
    }, [state]);

    useEffect(() => {
        updateState({
            ...state,
            organisation,
        });
    }, [organisation]);

    useEffect(() => {
        (async () => {
            try {
                await Auth.currentAuthenticatedUser();
                await Auth.currentSession();
                refreshCoreData();

                let additionalStateData = {};
                try {
                    const {
                        data: { proposals },
                    } = await axios.get(`${process.env.REACT_APP_AQRU_AI_API}/template-proposals`);

                    additionalStateData = {
                        proposals,
                        proposalsFiltered: proposals,
                    };
                } catch (e) {
                    // swallow
                }

                updateState({
                    ...state,
                    loading: false,
                    ...additionalStateData,
                });
            } catch (e) {
                logout();
                navigate('/');
            }
        })();
    }, []);

    const attributeOptions = lookupAttributeOptions(organisation);

    useEffect(() => {
        const intervalId = setInterval(() => {
            (async () => {
                if (stateRef.current.view !== 'configure') return;

                await saveProposal(stateRef.current, updateState, true);
            })();
        }, 12000);

        return () => clearInterval(intervalId);
    }, [state.proposal, state.proposal?.id]);

    return (
        <>
            <Flex
                sx={{
                    minHeight: '100vh',
                    paddingBottom: '100px',
                    width: '100vw',
                    flexDirection: 'column',
                    position: 'relative',
                    backgroundSize: 'cover',
                }}
                data-testid="home-screen"
            >
                <Flex
                    sx={{
                        minHeight: '100vh',
                        width: '100vw',
                        flexDirection: 'column',
                    }}
                >
                    <Sidebar
                        currentPage="Proposals"
                        overlay={overlay}
                        accountSummary={accountSummary}
                        user={user}
                        copy={{}}
                        settingsJourney={settingsJourney}
                        updateSettingsJourney={updateSettingsJourney}
                    />

                    {state.loading && <Spinner />}

                    <Flex
                        sx={{
                            minHeight: 'calc(100vh)',
                            borderTopLeftRadius: '25px',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            mt: '0px',
                            border: `1px solid ${theme.colors.whiteBlockBorder}`,
                            borderRadius: 20,
                            padding: '30px 30px',
                            minWidth: 370,
                            backgroundColor: 'white',
                            ml: 260,
                            mr: 20,
                        }}
                    >
                        <Flex
                            sx={{
                                flexDirection: 'column',
                            }}
                        >
                            <Flex
                                sx={{
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    width: '100%',
                                    mb: '30px',
                                }}
                            >
                                <Flex
                                    sx={{
                                        flexDirection: 'column',
                                        width: 1300,
                                    }}
                                >
                                    {state.view === 'configure' && (
                                        <ConfigureProposal
                                            state={state}
                                            updateState={updateState}
                                            organisation={organisation}
                                            attributeOptions={attributeOptions}
                                            attributeTypes={attributeTypes}
                                        />
                                    )}

                                    {state.view === 'list' && (
                                        <Flex
                                            sx={{
                                                paddingLeft: 10,
                                                paddingBottom: 30,
                                                mt: 0,
                                                flexDirection: 'column',
                                            }}
                                        >
                                            {state.showDeleteConfirmation && (
                                                <ConfirmDialog
                                                    updateState={updateState}
                                                    state={state}
                                                    stateKey="showDeleteConfirmation"
                                                    text="Are you sure you wish to delete this template proposal?"
                                                />
                                            )}
                                            <Paragraph sx={{ fontWeight: 400, fontSize: 25 }}>
                                                Template Proposals
                                            </Paragraph>
                                            <Divider mt={10} width={1250} />
                                            <Paragraph sx={{ fontWeight: 400, mt: 0, mb: 20 }}>
                                                Setup templates of proposals that can be sent to client portal users to
                                                complete.
                                            </Paragraph>

                                            <Button
                                                onClick={() =>
                                                    updateState({ ...state, view: 'configure', proposal: {} })
                                                }
                                                sx={{ mb: 20, width: 100, height: 40 }}
                                            >
                                                New
                                            </Button>

                                            <Input
                                                sx={{
                                                    mb: '25px',
                                                    width: '350px',
                                                    background: '#FFFFFF',
                                                    border: '1px solid #a3a69b',
                                                    borderRadius: '10px',
                                                    height: '42px',
                                                    fontSize: '14px',
                                                }}
                                                aria-labelledby="fn-label"
                                                type="text"
                                                id="searchName"
                                                data-testid="searchName"
                                                name="searchName"
                                                label=""
                                                placeholder={'Search by proposal name'}
                                                onChange={handleSearchByNameChange}
                                                error={null}
                                            />

                                            <table
                                                style={{
                                                    width: 900,
                                                    marginBottom: 30,
                                                    borderCollapse: 'collpase',
                                                    fontSize: 14,
                                                }}
                                            >
                                                <thead
                                                    style={{
                                                        backgroundColor: theme.colors.primary,
                                                        color: 'white',
                                                        cursor: 'pointer',
                                                        position: 'sticky',
                                                        top: 0,
                                                    }}
                                                >
                                                    <tr>
                                                        <th
                                                            onClick={() => {
                                                                const direction =
                                                                    state.sortByDirections?.[0] === 'ASC'
                                                                        ? 'DESC'
                                                                        : 'ASC';
                                                                updateState({
                                                                    ...state,
                                                                    sortByDirections: [direction],
                                                                    sortByKeys: ['name'],
                                                                });
                                                            }}
                                                            style={{ width: 200, textAlign: 'left', padding: 20 }}
                                                        >
                                                            Name
                                                        </th>
                                                        <th style={{ width: 500, textAlign: 'left', padding: 20 }}>
                                                            Description
                                                        </th>
                                                        <th style={{ textAlign: 'left', padding: 20 }}></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {(state.sortByDirections?.[0]
                                                        ? state.proposalsFiltered?.sort((x, y) => {
                                                              if (state.sortByDirections?.[0] === 'DESC') {
                                                                  return y.name
                                                                      ?.toLowerCase()
                                                                      ?.localeCompare(x.name?.toLowerCase());
                                                              }

                                                              return x.name
                                                                  ?.toLowerCase()
                                                                  ?.localeCompare(y.name?.toLowerCase());
                                                          })
                                                        : state.proposalsFiltered
                                                    )?.map((proposal) => (
                                                        <tr style={{}} key={proposal.id}>
                                                            <td
                                                                style={{
                                                                    width: 200,
                                                                    padding: 20,
                                                                    cursor: 'pointer',
                                                                }}
                                                            >
                                                                {proposal.name}
                                                            </td>
                                                            <td style={{ width: 200, padding: 20 }}>
                                                                {proposal?.description || ''}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    padding: 20,
                                                                    cursor: 'pointer',
                                                                }}
                                                            >
                                                                <Flex sx={{ flexDirection: 'column' }}>
                                                                    <Button
                                                                        variant="light"
                                                                        sx={{ width: 120 }}
                                                                        onClick={() => {
                                                                            updateState({
                                                                                ...state,
                                                                                view: 'configure',
                                                                                proposal,
                                                                            });
                                                                        }}
                                                                    >
                                                                        <i
                                                                            style={{
                                                                                fontSize: '12px',
                                                                                cursor: 'pointer',
                                                                                marginRight: '7px',
                                                                            }}
                                                                            className="fas fa-pencil"
                                                                            aria-hidden="true"
                                                                        />
                                                                        Edit
                                                                    </Button>
                                                                    <Button
                                                                        variant="light"
                                                                        onClick={async () => {
                                                                            await clone(proposal, state, updateState);
                                                                        }}
                                                                        sx={{ mt: 10, width: 120 }}
                                                                    >
                                                                        <i
                                                                            style={{
                                                                                fontSize: '12px',
                                                                                cursor: 'pointer',
                                                                                marginRight: '7px',
                                                                            }}
                                                                            className="fas fa-clone"
                                                                            aria-hidden="true"
                                                                        />
                                                                        Clone
                                                                    </Button>
                                                                    <Button
                                                                        variant="light"
                                                                        onClick={() =>
                                                                            updateState({
                                                                                ...state,
                                                                                showDeleteConfirmation: true,
                                                                                confirmCallback: deleteProposal(
                                                                                    proposal.id,
                                                                                    state,
                                                                                    updateState
                                                                                ),
                                                                            })
                                                                        }
                                                                        sx={{ color: 'red', mt: 10, width: 120 }}
                                                                    >
                                                                        <i
                                                                            style={{
                                                                                fontSize: '12px',
                                                                                cursor: 'pointer',
                                                                                color: 'red',
                                                                                marginRight: '7px',
                                                                            }}
                                                                            className="fas fa-trash"
                                                                            aria-hidden="true"
                                                                        />
                                                                        Delete
                                                                    </Button>
                                                                </Flex>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </Flex>
                                    )}
                                </Flex>
                            </Flex>
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>
        </>
    );
};

const mapDispatchToProps = (dispatch) => ({
    refreshCoreData: () => dispatch({ type: userActions.REFRESH_CORE_DATA }),
    logout: () => dispatch({ type: 'LOGOUT' }),
    dismissTopMenu: () => dispatch({ type: menuActions.DISMISS_TOP_MENU }),
});

const mapStateToProps = (state) => {
    const { account } = state;
    return {
        loggedIn: account.loggedIn,
        dataLoading: account.loading,
        userData: account.user,
        timestampOfLastDataLoad: account.timestampOfLastDataLoad,
        isMobile: account.isMobile,
        accountSummary: account.accountSummary,
        organisation: account.organisation,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Proposals);
